import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';

interface TabPanelProps {
  children: React.ReactNode;
  currentTab: string;
  value: string;
  ariaLabel: string;
  customTabPanelSx?: SxProps;
}

const tabPanelSx = (theme: Theme) => ({
  width: '100%',
  height: 'calc(100% - 32px)',
  overflow: 'auto',
  [theme.breakpoints.down('md')]: {
    height: '100%',
  },
});

const TabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = (props) => {
  const {
    children, value, currentTab, ariaLabel, customTabPanelSx,
  } = props;

  return (
    (
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      <Box
        role="tabpanel"
        hidden={value !== currentTab}
        aria-expanded={value === currentTab}
        aria-label={`${ariaLabel}-tab`}
        sx={[
          tabPanelSx,
          ...(Array.isArray(customTabPanelSx) ? customTabPanelSx : [customTabPanelSx]),
        ]}
      >
        {children}
      </Box>
    )
  );
};

export default TabPanel;
